import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a7f203ebedae7001435b87c_1786728545895_853542e3/msmvportal/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a7f203ebedae7001435b87c_1786728545895_853542e3/msmvportal/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a7f203ebedae7001435b87c_1786728545895_853542e3/msmvportal/src/components/ui/AppLogo.tsx");
